/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "4461639e12c61b8d4184e69b505d9fc2a734c283";
